import axios from "axios";
import authHeader from "../utils/authHeader";

const API_URL = process.env.VUE_APP_API_URL;

export const getAll = (params) => {
  return axios.post(API_URL + "device/metadata/list", params, { headers: authHeader() });
};

export const create = (params) => {
  return axios.post(API_URL + "device/metadata/", params, { headers: authHeader() });
};

export const update = (params) => {
  return axios.put(API_URL + "device/metadata/", params, { headers: authHeader() });
};

export const remove = (params) => {
  return axios.delete(API_URL + "device/metadata/", { data: params, headers: authHeader() });
};
